import { __rest } from './../../external/tslib/tslib.es6.js';
import React, { forwardRef } from 'react';
import { Suprefix, StyledTextarea } from './styles.js';
import { SuprefixContent } from './SuprefixContent.js';

const TextareaBody = forwardRef((_a, ref) => {
    var { feedback, disabled, readOnly, isLoading, required, id, helperText, showFeedbackIcon = true, prefix: Prefix, suffix: Suffix } = _a, props = __rest(_a, ["feedback", "disabled", "readOnly", "isLoading", "required", "id", "helperText", "showFeedbackIcon", "prefix", "suffix"]);
    const hasInteractiveEl = () => {
        if (isLoading || feedback)
            return !disabled && !readOnly;
    };
    return (React.createElement(React.Fragment, null,
        Prefix && (React.createElement(Suprefix, null,
            React.createElement(SuprefixContent, { el: Prefix }))),
        React.createElement(StyledTextarea, Object.assign({}, props, { required: required, id: id, disabled: disabled, readOnly: readOnly, ref: ref, hasPrefix: Boolean(Prefix) })),
        hasInteractiveEl() && showFeedbackIcon && (React.createElement(Suprefix, { sufix: true, hasSuffix: Boolean(Suffix) },
            React.createElement(SuprefixContent, { isLoading: isLoading, feedback: feedback, showFeedbackIcon: showFeedbackIcon, hasInteractiveEl: true }))),
        Suffix && (React.createElement(Suprefix, { sufix: true },
            React.createElement(SuprefixContent, { el: Suffix })))));
});
TextareaBody.displayName = 'TextareaBody';

export { TextareaBody };
